import { useGetOrganizationQuery } from "../store/apiSlice/accountApiSlice";
import { resolvePlaceTimezone } from "./dateTime";

/**
 * Default zone when typing a clock: site if given, else company, else UTC.
 *
 * @param {{siteTimezone?: string, companyTimezone?: string}} [places]
 * @return {string}
 */
export const usePlaceTimezone = ({ siteTimezone, companyTimezone } = {}) => {
  const { data } = useGetOrganizationQuery();
  return resolvePlaceTimezone({
    siteTimezone,
    companyTimezone: companyTimezone || data?.timezone,
  });
};
